<template>
  <div class="logo">
    <img class="logo__img" :src="logo"/>
  </div>
</template>

<script>
import logoNextories from '@/assets/img/logo-nextories.png';

export default {
  name: 'logo',
  computed: {
    logo() {
      return logoNextories;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: inline-block;
  line-height: normal;
  height: 59px;
  width: var(--nxt-left-menu-size);
  padding-left: 20px;
  &__img {
    vertical-align: middle;
    margin: 15px 0 5px 0;
    height: 40px;
  }
}
</style>
